var bps4Loaded = false;
function checkBps4Loaded(time) {
    if (!bps4Loaded) {
        if (typeof time == 'undefined') {
            time = 10000;
        }
        console.log('check BPS');
        // bps4Loaded = false;
        setTimeout(function (args) {
            if (!bps4Loaded) {
                $('#modalAdblock').addClass('open');
                sendToTagManager('bps_blocked_on_action', 'true');
            }
        }, time);
    }
}

var bps4LoadedBackground = false;
function checkBps4LoadedBackground(time) {
    if (!bps4LoadedBackground) {
        if (typeof time == 'undefined') {
            time = 10000;
        }
        console.log('check BPS Background');
        // bps4LoadedBackground = false;
        setTimeout(function (args) {
            if (!bps4Loaded) {
                sendToTagManager('bps_blocked', 'true');
            }
        }, time);
    }
}
checkBps4LoadedBackground();